import { Entity } from '../common/entity'
import { Permission } from './permission'

/**
 * Entity with permissions, base class for such specific principals
 * as {@link SecurityProfile} or {@link Account}
 */
export class Principal extends Entity {
  constructor (data = {}) {
    super()

    this.assign({
      ...data,
      isEnabled: data.isEnabled == null ? true : data.isEnabled
    })
  }

  /**
   * Normalizes the assigned data
   */
  normalize () {
    super.normalize()
    this.allow = this.allow || []
    this.deny = this.deny || []
  }

  /**
   * Description
   * @type {String}
   */
  description

  /**
 * Indicates whether the principal is currently enabled
 * @type {Boolean}
 */
  isEnabled

  /**
   * Features permitted for the principal
   * @type {Boolean|Array[String]}
   */
  allow

  /**
   * Features denied to the principal.
   * If a feature is listed here, it suppresses its presence in {@link allow} list
   * @type {Boolean|Array[String]}
   */
  deny

  /**
   * Checks if principal can use the specified feature
   * @param {String} name Feature name
   * @returns {Boolean}
   */
  canUse (name) {
    const isDenied = this.deny.includes(Permission.ALL) || this.deny.includes(name)
    const canUse = !isDenied && (this.allow.includes(Permission.ALL) || this.allow.includes(name))
    return canUse
  }

  /**
   * Checks if principal cannot use the specified feature
   * @param {String} name Feature name
   * @returns {Boolean}
   */
  cannotUse (name) {
    return !this.canUse(name)
  }

  /**
   * Overrides serialization to prevent serializing of certain runtime-only properties
   * @returns {Object}
   */
  toJSON () {
    const result = { ...this }
    return result
  }
}
